/**
 * ThemeContext.js — 모비딕의 화이트·세이지 테마.
 * 기기/이전 저장 설정과 관계없이 공통 테마와 분기 렌더링을 light로 맞춘다.
 * 색상 정본은 마지막에 불러오는 ssehada-theme.css다.
 */
import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext(null);

const FORCED_THEME = 'light';

export function ThemeProvider({ children }) {
  const theme = FORCED_THEME;

  /* 과거 테마 설정이 새 공통 테마를 덮지 않도록 정리한다. */
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.removeItem('app-theme'); } catch {}
  }, [theme]);

  /* 단일 테마. 기존 소비자와의 컨텍스트 API 호환을 유지한다. */
  const toggleTheme = () => {};
  const isDark = false;

  return (
    <ThemeContext.Provider value={{ theme, isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
